import { GetBackListeElettoraliIdMembriParams } from '@framework/api-client';
import {
  ColumnSortDirections,
  createColumnFilter,
  getOrderBy,
  getOrderDirection,
  withA11yFilterIcon,
} from '@framework/ui';
import type { ColumnType } from 'antd/es/table';
import { useMemo } from 'react';
import { getRenderByDatatype } from '../form/getRenderByDatatype';
import { getWidgetCandidateColumns } from '../form/getWidgetCandidateColumns';
import type { ICandidateWidget } from '../ICandidateWidget';
import { sortCandidateColumns } from './sortCandidateColumns';

/**
 * Hook per ottenere le colonne della tabella dei candidati con i relativi tipi
 */
export function useCandidateWidgetColumnsTypes(
  widget: ICandidateWidget,
  query: GetBackListeElettoraliIdMembriParams,
) {
  const memberColumns = useMemo(() => {
    const rawColumns = getWidgetCandidateColumns(widget);

    // Ordina le colonne in base all'ordine definito nel widget
    const sortedColumns = sortCandidateColumns(rawColumns, widget.columns);

    const queryOrder = getOrderBy(query);
    const queryDirection = getOrderDirection(query);

    return sortedColumns.map(col => {
      const isCurrentField = queryOrder === col.name && queryDirection;
      const direction =
        queryDirection === ColumnSortDirections.ascend ? 'ascend' : 'descend';
      const sortOrder = isCurrentField ? direction : undefined;

      return {
        title: col.label,
        dataIndex: col.name,
        key: col.name,
        ...(col.filterType ? createColumnFilter(col.filterType) : {}),
        sorter: col.sorter ?? false,
        filterIcon: col.filterType ? withA11yFilterIcon(col.label) : undefined,
        sortOrder,
        render: getRenderByDatatype(col.type),
      } as ColumnType;
    });
  }, [widget, query]);

  return memberColumns;
}
